var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 14L0.833333 8.55556V7H3.75C4.48611 7 5.12167 6.77626 5.65667 6.32878C6.19167 5.8813 6.51444 5.32726 6.625 4.66667H0V3.11111H6.375C6.13889 2.65741 5.78806 2.28459 5.3225 1.99267C4.85694 1.70074 4.33278 1.55504 3.75 1.55556H0V0H10V1.55556H7.29167C7.48611 1.77593 7.65972 2.01574 7.8125 2.275C7.96528 2.53426 8.08333 2.81296 8.16667 3.11111H10V4.66667H8.3125C8.20139 5.76852 7.71528 6.69226 6.85417 7.43789C5.99306 8.18352 4.95833 8.55607 3.75 8.55556H3.14583L8.75 14H6.4375Z",
    fill: "#696974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupay);
export default __webpack_public_path__ + "static/media/rupay.5dcf4fe9afcd14da2ede5300a7167d75.svg";
export { ForwardRef as ReactComponent };